import { render, staticRenderFns } from "./IconLeaf.vue?vue&type=template&id=cca24544&scoped=true&"
import script from "./IconLeaf.vue?vue&type=script&lang=ts&"
export * from "./IconLeaf.vue?vue&type=script&lang=ts&"
import style0 from "./IconLeaf.vue?vue&type=style&index=0&id=cca24544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca24544",
  null
  
)

export default component.exports